// ─── Single source of truth for route access ──────────────────────────
// Both the edge middleware (src/proxy.ts) and the client auth provider
// (src/providers/supabase-auth-provider.tsx) import from here so their
// notion of "what is public" can never drift apart again. Add a public
// route in ONE place: this file.

/** Rutas accesibles por cualquiera, autenticado o no. */
export const PUBLIC_ROUTES = [
  "/job/",
  "/landing/",
  "/signature-contract",
  "/terms-and-conditions",
  "/privacy-policy",
  "/peer-to-peer",
  "/outsorcing",
  "/complete-questionary",
  "/quote-proposal",
  "/impersonate",
  "/The-Smart-Team-Scaling-Playbook.pdf",
  "/Jobbi-9-Prompts-for-HR-Teams.pdf",
  "/Jobbi-9-Prompts-para-equipos-de-Recursos-Humanos.pdf",
  "/Jobbi-HR-Dashboard-Template.xlsx",
  "/Jobbi-Onboarding-Milestone-Tracker-HR.xlsx",
  "/Jobbi-Hiring-Posts-Template-Pack.pdf",
  "/Jobbi-Plantillas-Para-Ofertas-Laborales.pdf",
] as const;

/**
 * Prefijos de infraestructura que el middleware deja pasar pero que el
 * cliente no necesita evaluar (nunca se navega a ellos como página).
 */
export const INFRA_PREFIXES = ["/_next/", "/api/", "/images/", "/public/"] as const;

/** True si la ruta es de cara al usuario y pública (sin contar infra). */
export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTES.some((route) => pathname.startsWith(route));
}

/** True si la ruta es pública o de infraestructura — usar en el edge. */
export function isPublicOrInfraRoute(pathname: string): boolean {
  return (
    isPublicRoute(pathname) ||
    INFRA_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
}
